<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <template v-slot:default="{ open }">
        <v-row no-gutters dense>
          <v-col cols="4">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>{{report.titolo}}</v-list-item-title>
                <v-list-item-subtitle>{{report.descrizione}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-card-title> -->
             <!--  {{report.titolo}} -->
            <!-- </v-card-title> -->
            <!-- <v-card-subtitle> -->
             <!-- {{report.descrizione}}-->
            <!-- </v-card-subtitle> -->
          </v-col>
          <v-col cols="8" class="text--secondary">
            <v-fade-transition leave-absolute>
              <span v-if="open" key="0">
              </span>
              <span v-else key="1">
                {{report.note}}
              </span>
            </v-fade-transition>
          </v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-container fluid>
        <v-row dense>
          <v-col cols="12" sm="2" md="2">
            <v-btn v-if="stampaBatch" color="primary" dark small class="mb-2" @click="stampaReportBatch()" dense width="130" :loading="batchInCorso">
              Stampa in batch
            </v-btn>     
            <v-btn v-else color="primary" dark small class="mb-2" @click="stampaReport()" dense width="130">
              Stampa report
            </v-btn>
            <br/>
            <v-btn v-if="stampaBatch" color="success" dark small class="mb-2" @click="generaExcelBatch()" dense width="130" :loading="generazioneExcelInCorso">
              Excel in batch
            </v-btn>              
            <v-btn v-else color="success" dark small class="mb-2" @click="generaExcel()" dense width="130" :loading="generazioneExcelInCorso">
              Genera Excel
            </v-btn>     
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-row v-for="(el, index) in filtriApplicabili.filter(x => ['Data', 'DataOra', 'Park'].includes(x.type))" :key="index" dense>
              <v-col>
                <component
                  :is="'p' + el.type"
                  :name="'p' + el.type + String(index)"
                  :item="el"
                  :key="updateTrigger"
                  @change="componentValueChange"
                />
              </v-col>
            </v-row>
            <div v-if="stampaBatch">{{ statusMessage }}</div>
          </v-col>     
          <v-col cols="12" sm="6" md="3">
            <v-row v-for="(el, index) in filtriApplicabili.filter(x => x.type === 'Switch')" :key="index" dense>
              <v-col>
                <component
                  :is="'p' + el.type"
                  :name="'p' + el.type + String(index)"
                  :item="el"
                  :key="updateTrigger"
                  @change="componentValueChange"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="3" >
            <v-radio-group v-model="prezzo" mandatory>
              <v-row v-for="(el, index) in filtriApplicabili.filter(x => x.type === 'Radio' && x.group === 'prezzo')" :key="index" dense>
                <v-col>
                  <component
                    :is="'p' + el.type"
                    :name="'p' + el.type + String(index)"
                    :item="el"
                    :key="updateTrigger"
                    :index="index"
                    @change="componentValueChange"
                  />
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-radio-group v-model="tipo" mandatory>
              <v-row v-for="(el, index) in filtriApplicabili.filter(x => x.type === 'Radio' && x.group === 'tipo')" :key="index" dense>
                <v-col>
                  <component
                    :is="'p' + el.type"
                    :name="'p' + el.type + String(index)"
                    :item="el"
                    :key="updateTrigger"
                    :index="index"
                    @change="componentValueChange"
                  />
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>                    
        </v-row>
      </v-container>
      <v-container fluid>
        <v-row dense>
          <v-col cols="12" sm="6" md="4" class="pr-5" v-for="(el, index) in filtriApplicabili.filter(x => ['Multiselect', 'Select'].includes(x.type))" :key="index">
            <component
              :is="'p' + el.type"
              :name="'p' + el.type + String(index)"
              :item="el"
              :key="updateTrigger"
              @change="componentValueChange"
            />
          </v-col>
        </v-row>
      </v-container>
      <dialog-errore :show="datiNonCompleti" title="Dati non completi" message="Verificare i valori inseriti !" @dialogConfirm="datiNonCompleti = false"/>
    </v-expansion-panel-content>
  </v-expansion-panel>

</template>

<script>
  import * as dot from 'dot-object'
  import _ from 'lodash'
  import moment from 'moment'
  import DialogErrore from '@/components/dialogErrore'
  import pData from '@/views/drawer/elementi/data'
  import pDataOra from './elementi/dataOra'
  import pMultiselect from './elementi/multiselecteWithGroupby'
  import pSwitch from './elementi/switch'
  import pRadio from './elementi/radio'
  import pPark from './elementi/park'
  import pSelect from './elementi/select'
  import configurazioni from '@/services/configurazioniService'
  import excelService from '@/services/excelService'
  import reporting from '@/services/reportingService'

  export default {
    components: {
      DialogErrore,
      pData,
      pDataOra,
      pSwitch,
      pRadio,
      pMultiselect,
      pPark,
      pSelect
    },
    props: {
      report: Object
    },
    data: () => ({
      date: null,
      filtri: [],
      datiNonCompleti: false,
      updateTrigger: 0,
      pathReportPrefix: '',
      prezzo: '',
      tipo: '',
      generazioneExcelInCorso: false,
      batchInCorso: false,
      intervalStatus: {},
      statusMessage: ''
    }),
    created() {
      this.pathReportPrefix = window.appConfig.VUE_APP_MOL_API_GATEWAY || ''
    },
    computed: {
      filtriApplicabili() {
        return this.report.filtri ? this.report.filtri.filter(x => x.type) : []
      },
      stampaBatch() {
        return this.report && this.report.usaModalitaBatch
      }
    },
    methods: {
      verificaStatoElaborazione() {
        this.intervalStatus = setInterval(async () => {
          const elaborazione = await reporting.statoElaborazione(this.report.nomeReport)
          const isRunning = elaborazione.running
          if (this.batchInCorso || this.generazioneExcelInCorso) {
            this.statusMessage = elaborazione.status
          }
          if (!isRunning) {
            clearInterval(this.intervalStatus)
            this.intervalStatus = null
            if (this.statusMessage === 'Dati pronti') {
              if (this.batchInCorso) {
                await this.stampaReport(true)
              }
              if (this.generazioneExcelInCorso) {
                await this.generaExcel(true)
              }
            }
            this.batchInCorso = false
            this.generazioneExcelInCorso = false
          }
          /*            else {
                      this.batchInCorso = true
                    } */
        }, 5000)
      },
      componentValueChange(data) {
        const { model, subModel, value, decimals } = data
        this.filtri[model] = data.value
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {
            s
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        if (model.startsWith('data')) {
          this.updateTrigger++
        }
      },
      async preparaRichiesta(tipo, batchResult) {
        const nomeReport = this.report.nomeReport
        let nonCompleti = false
        this.report.filtri.forEach(el => {
          if (el.required && !el.value) {
            nonCompleti = true
          }
        })
        if (nonCompleti) {
          this.datiNonCompleti = true
          return ''
        } else {
          const start = this.filtri.dataDa ? moment(this.filtri.dataDa).format('YYYYMMDD') : 'ddd' // nel caso il report non li prevedesse
          // TODO: Sistemare. Aggiungere un giorno non è corretto. Andrebbe usato endOf('day'), ma vanno rivisti tutti i report che utilizzano il filtro
          const stop = this.filtri.dataA ? moment(this.filtri.dataA).add(1, 'days').format('YYYYMMDD') : 'aaa'

          let startOrario = this.filtri.dataDa ? moment(this.filtri.dataDa) : 'ddd'
          let endOrario = this.filtri.dataA ? moment(this.filtri.dataA) : 'aaa'
          if (startOrario.toString() === endOrario.toString()) {
            startOrario = null
            endOrario = null
          }
          const filtriAggiuntivi = []
          let filtriCustom = null
          const esclusi = ['mostraArticoli','includiGiacenzaPositiva','includiGiacenzaNegativa', 'includiGiacenzaNulla', 'valorizzaPrezzo', 'tipoApplicazione']
          this.report.filtri.filter(x => 
            !['dataDa', 'dataA'].includes(x.model)
            && (x.model && !x.model.startsWith('rag-') && !x.model.startsWith('new-')
            && !esclusi.includes(x.model))).forEach(el => {
            var ff
            if (typeof this.filtri[el.model] === 'boolean') {
              ff = this.filtri[el.model]
            } else {
              ff = _.pickBy(this.filtri[el.model])
            }
            if (this.filtri[el.model] && ff) {
              if (typeof this.filtri[el.model] === 'boolean') {
                filtriAggiuntivi.push({ chiave: el.model, valori: ff, applicazione: el.applicazione })
              } else {
                if (el.filtroRecord) {
                  filtriCustom = {
                    selector: el.model,
                    value: Object.values(ff)
                  }
                  if (el.command) {
                    filtriCustom.command = el.command
                  }
                }
                filtriAggiuntivi.push({ chiave: el.model, valori: Object.values(ff), applicazione: el.applicazione })
              }
            } else {
              filtriAggiuntivi.push({ chiave: el.model, valori: [], applicazione: el.applicazione }) // serve il tipo applicazione per eventuale raggruppamento
            }
          })
          const raggruppamenti = []
          const newPage = []
          Object.keys(this.filtri).filter(x => x.startsWith('rag-')).forEach(el => {
            console.log('-->', el)
            const chiave = el.substring(4)
            if (chiave === 'data') {
              raggruppamenti.push({ chiave: 'data', applicazione: 'movimenti' })
            } else if (chiave === 'codice') {

              raggruppamenti.push({ chiave: 'codice', applicazione: 'prodotti' }) // verificare
            } else {
              const filtro = this.report.filtri.find(x => x.model === chiave)
              raggruppamenti.push({ chiave: filtro.model, applicazione: filtro.applicazione, stampa: filtro.modelPrint || filtro.model })
            }
          })
          Object.keys(this.filtri).filter(x => x.startsWith('new-')).forEach(el => {
            console.log('-->', el)
            const chiave = el.substring(4)
            if (chiave === 'data') {
              newPage.push({ chiave: 'data', applicazione: 'movimenti' })
            } else {
              const filtro = this.report.filtri.find(x => x.model === chiave)
              newPage.push({ chiave: filtro.model, applicazione: filtro.applicazione, stampa: filtro.modelPrint || filtro.model })
            }
          })
          // TODO: Andrebbe definito un payload generico invece di separare tutte le variabili ...
          const articoli = this.filtri.mostraArticoli ? this.filtri.mostraArticoli : false
          const giacenza = {
            positiva: this.filtri ? this.filtri.includiGiacenzaPositiva : false,
            nulla: this.filtri ? this.filtri.includiGiacenzaNulla : false,
            negativa: this.filtri ? this.filtri.includiGiacenzaNegativa: false
          }
          const valorizza = this.filtri && this.filtri.valorizzaPrezzo === 1 ? 'vendita' : 'acquisto'
          const tipoApplicazione = this.filtri ? this.filtri.tipoApplicazione : 0
          const posizione = this.filtri ? this.filtri.posizione : []
          let impostazioni = null
          if (this.report.impostazioni) {
            if (typeof this.report.impostazioni === 'string') {
              const conf = this.report.impostazioni.split('.')
              if (conf && conf.length === 2) {
                impostazioni = await configurazioni.getConfigurazione(conf[0], conf[1])
              } else {
                impostazioni = this.report.impostazioni // TODO: Verificare.
              }
            } else {
              impostazioni = this.report.impostazioni // TODO: Verificare
            }
          }
          let parametri = {
            // TODO--> togliere la sezione intestazione. Vanno aggiornati tutti i database dei clienti
            intestazione: {
              titolo: this.report.descrizione,
              titolo_01_sx: this.report.titolo_01_sx,
              titolo_02_sx: this.report.titolo_02_sx,
              titolo_01_cx: this.report.titolo_01_cx
            },
            caricaLoghi: this.report.caricaLoghi || false,
            autoPrint: this.report.autoPrint || false,
            reportHeader: this.report.reportHeader || null,
            pageHeader: this.report.pageHeader || null,
            pageFooter: this.report.pageFooter || null,
            reportFooter: this.report.reportFooter || null,
            articoli: articoli,
            filtri: filtriAggiuntivi,
            filtriCustom: filtriCustom,
            gruppi: raggruppamenti,
            newPage: newPage,
            impostazioni: impostazioni,
            giacenza: giacenza,
            valorizza,
            tipoApplicazione,
            dettaglio: this.report.dettaglio,
            startOrario,
            endOrario,
            // batchResult: !!batchResult,
            mostraSpedizione: this.report.mostraSpedizione || false,
            posizione
          }
          if (batchResult) {
            parametri.batchResult = !!batchResult
          }

          const str = JSON.stringify(parametri)
          // const source = `${this.pathReportPrefix}/reporting/pdfm/${nomeReport}/${start}/${stop}?par=${btoa(str)}`
          const buff = Buffer.from(str, "utf-8")
          const source = `${this.pathReportPrefix}/reporting/${tipo || 'pdfm'}/${nomeReport}/${start}/${stop}?par=${buff.toString('base64')}`
          // this.$router.push({ name: 'Pdf', params: { source: source } })
          return source
        }
      },
      async stampaReport(batch) {
        const source = await this.preparaRichiesta('pdfm', batch)
        if (source) {
          this.$router.push({ name: 'Pdf', params: { source: source } })
        }
      },
      async stampaReportBatch() {
        const source = await this.preparaRichiesta('batch')
        const nomeFile = `${this.report.titolo}_${moment().format('YYYYMMDDHHmmss')}.csv`
        const result = await reporting.submitBatchReport(source, nomeFile)
        if (result && result.status === 'scheduled') {
          this.batchInCorso = true
          this.verificaStatoElaborazione()
        } else {
          alert('Errore avvio procedura !')
        }
      },      
      async generaExcel(batch) {
        this.generazioneExcelInCorso = true
        const source = await this.preparaRichiesta('rawm', batch)
        if (source) {
          const dati = await excelService.creaExcelFromSource(source, this.report.titolo + '.xlsx')
        }
        this.generazioneExcelInCorso = false
      },
      async generaExcelBatch() {
        const source = await this.preparaRichiesta('batch')
        const nomeFile = `${this.report.titolo}_${moment().format('YYYYMMDDHHmmss')}.csv`
        const result = await reporting.submitBatchReport(source, nomeFile)
        if (result && result.status === 'scheduled') {
          this.generazioneExcelInCorso = true
          this.verificaStatoElaborazione()
        } else {
          alert('Errore avvio procedura !')
        }
      }
    }
  }
</script>
